import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const logPrintJobProcessing = {
  name: "logPrintJobProcessing" as const,
  input: z.object({
    job: z.object({
      batch: z.union([
        z.object({ fulfillmentGroupIds: z.array(z.string()) }),
        z.object({ batchId: z.string() }),
      ]),
      document: z.string(),
      printOptions: z.object({
        idempotencyKey: z.string().nullish(),
        printerId: z.number().nullish(),
        templateId: z.string().nullish(),
        printFast: z.boolean().nullish(),
        printerOptions: z.any().nullish(),
      }),
    }),
    action: createEnum(["starting", "completed", "failed"]),
    queueIndex: z.number(),
    queueLength: z.number(),
    error: z.string().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
